import {
  Button,
  Form,
  LoadingSpinner,
  TextFormField,
  Typography,
} from "@/components/ui";
import { zodResolver } from "@hookform/resolvers/zod";
import { type SubmitHandler, useForm } from "react-hook-form";
import { z } from "zod";

const formSchema = z.object({
  email: z.string().email().max(50),
});

interface ForgotPasswordFormProps {
  onSubmit: SubmitHandler<z.infer<typeof formSchema>>;
  isLoading?: boolean;
}

function ForgotPasswordForm({
  onSubmit,
  isLoading = false,
}: ForgotPasswordFormProps) {
  const form = useForm<z.infer<typeof formSchema>>({
    resolver: zodResolver(formSchema),
    values: {
      email: "",
    },
    mode: "onSubmit",
  });

  //arg: data: z.infer<typeof formSchema>

  return (
    <Form {...form}>
      <form
        onSubmit={form.handleSubmit(onSubmit)}
        className="mt-8 flex flex-col gap-y-4"
      >
        <Typography variant="bold">
          Enter your email to receive a reset link.
        </Typography>
        <TextFormField
          register={form.register("email")}
          label="Email"
        ></TextFormField>
        <div className="text-right">
          <Button
            type="submit"
            variant="foreground"
            className="mt-4 w-full"
            disabled={isLoading}
          >
            {isLoading ? <LoadingSpinner /> : "Send reset link"}
          </Button>
        </div>
      </form>
    </Form>
  );
}

export { ForgotPasswordForm };
